export default {
  ResizableColumn: {
    mounted() {
      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onPointerMove = this.handlePointerMove.bind(this);
      this.onPointerUp = this.handlePointerUp.bind(this);

      this.el.addEventListener('pointerdown', this.onPointerDown);
    },

    destroyed() {
      this.el.removeEventListener('pointerdown', this.onPointerDown);
      this.endResize();
    },

    scopeRoot() {
      return this.el.closest('[data-resizable-column-scope]') || this.el;
    },

    handlePointerDown(event) {
      if (event.button !== 0) return;

      const handle = event.target.closest('[data-resize-handle]');
      if (!handle || !this.el.contains(handle)) return;

      const cell = handle.closest('[data-resizable-header-cell-for]');
      if (!cell) return;

      if (this.drag) this.endResize();

      event.preventDefault();

      this.drag = {
        handle,
        columnName: cell.dataset.resizableHeaderCellFor,
        startX: event.clientX,
        startWidth: cell.offsetWidth,
        minWidth: parseInt(this.el.dataset.resizableColumnMinWidth, 10),
        pointerId: event.pointerId,
        // Stays null until the pointer actually moves, so a click that never
        // dragged commits nothing.
        width: null,
      };

      handle.setPointerCapture(event.pointerId);
      handle.setAttribute('data-resizing', '');

      handle.addEventListener('pointermove', this.onPointerMove);
      handle.addEventListener('pointerup', this.onPointerUp);

      // pointercancel and lostpointercapture are the safety net: unlike a mouseup
      // on document, they still fire when the gesture ends off-window or the
      // browser takes the capture away, so the drag can never get stuck.
      handle.addEventListener('pointercancel', this.onPointerUp);
      handle.addEventListener('lostpointercapture', this.onPointerUp);
    },

    handlePointerMove(event) {
      const drag = this.drag;
      if (!drag) return;

      const width = Math.max(drag.minWidth, drag.startWidth + (event.clientX - drag.startX));
      if (width === drag.width) return;

      drag.width = width;
      this.setColumnWidth(drag.columnName, width);
    },

    setColumnWidth(columnName, width) {
      const cells = this.scopeRoot().querySelectorAll(`[data-resizable-header-cell-for="${columnName}"]`);

      for (const cell of cells) {
        cell.style.width = `${width}px`;
      }
    },

    handlePointerUp() {
      const drag = this.drag;
      if (!drag) return;

      const { columnName, width } = drag;

      this.endResize();

      if (width === null) return;

      this.pushEvent(this.el.dataset.resizableColumnEvent, {
        column_name: columnName,
        new_width: width,
      });
    },

    endResize() {
      const drag = this.drag;
      if (!drag) return;

      this.drag = null;

      const { handle, pointerId } = drag;

      handle.removeEventListener('pointermove', this.onPointerMove);
      handle.removeEventListener('pointerup', this.onPointerUp);
      handle.removeEventListener('pointercancel', this.onPointerUp);
      handle.removeEventListener('lostpointercapture', this.onPointerUp);

      if (handle.hasPointerCapture(pointerId)) handle.releasePointerCapture(pointerId);
      handle.removeAttribute('data-resizing');
    },
  },
};
